"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createWriterShardPrefix = createWriterShardPrefix;
exports.createWriterShardId = createWriterShardId;
/** Stable ownership prefix of one Yjs writer. */
function createWriterShardPrefix(clientID) {
    return `writer-${clientID.toString(36)}-`;
}
/** A fresh shard identity, also usable by planners given an existing prefix. */
function createWriterShardId(prefix) {
    return `${prefix}${globalThis.crypto.randomUUID()}`;
}
